/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { FiltrazioneDto, GetFiltrazioniParams } from ".././models";

export const getFiltrazioni = (
  portale: 1 | 2 | 3,
  params?: GetFiltrazioniParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<FiltrazioneDto[]>> => {
  return axios.get(`/api/portali/${portale}/filtrazioni`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetFiltrazioniQueryKey = (
  portale: 1 | 2 | 3,
  params?: GetFiltrazioniParams
) =>
  [`/api/portali/${portale}/filtrazioni`, ...(params ? [params] : [])] as const;

export const getGetFiltrazioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiltrazioni>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetFiltrazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFiltrazioni>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getFiltrazioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFiltrazioniQueryKey(portale, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiltrazioni>>> = ({
    signal,
  }) => getFiltrazioni(portale, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!portale, ...queryOptions };
};

export type GetFiltrazioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiltrazioni>>
>;
export type GetFiltrazioniQueryError = AxiosError<unknown>;

export const useGetFiltrazioni = <
  TData = Awaited<ReturnType<typeof getFiltrazioni>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetFiltrazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFiltrazioni>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFiltrazioniQueryOptions(portale, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetFiltrazioni = () =>
  //@ts-ignore
  useGetFiltrazioni(...([] as any[]));
